export default __webpack_public_path__ + "font-symbol-of-letter-a.png";